export * from './dom/IVirtualElement';
export * from './dom/elementContains';
export * from './dom/elementContainsAttribute';
export * from './dom/findElementRecursive';
export * from './dom/getChildren';
export * from './dom/getDocument';
export * from './dom/getParent';
export * from './dom/getRect';
export * from './dom/getVirtualParent';
export * from './dom/getWindow';
export * from './dom/isVirtualElement';
export * from './dom/on';
export * from './dom/portalContainsElement';
export * from './dom/raiseClick';
export * from './dom/setPortalAttribute';
export * from './dom/setVirtualParent';
//# sourceMappingURL=dom.js.map